/* Ürün Listesi 2 — sıralama, ızgara yoğunluğu, filtre paneli */
(function () {
  var root = document.querySelector('[data-lc2]');
  if (!root) return;
  var grid = root.querySelector('[data-lc2-grid]');
  var store = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };

  /* Kategori şeridi: aktif kategoriyi görünür alana getir */
  var navTrack = root.querySelector('.lc2-nav__track');
  var navActive = navTrack && navTrack.querySelector('.is-active');
  if (navActive && navTrack.scrollWidth > navTrack.clientWidth) {
    navTrack.scrollLeft = navActive.offsetLeft - (navTrack.clientWidth - navActive.offsetWidth) / 2;
  }
  var navFit = function () { if (navTrack) navTrack.parentElement.classList.toggle('is-overflow', navTrack.scrollWidth > navTrack.clientWidth + 1); };
  navFit();
  window.addEventListener('resize', navFit);

  /* Sıralama */
  var sort = root.querySelector('[data-lc2-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* Izgara yoğunluğu (masaüstü 2/3/4, mobil 1/2/3) */
  var setCols = function (n, save) {
    if (!grid) return;
    grid.style.setProperty('--cols', n);
    root.querySelectorAll('[data-lc2-cols]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.lc2Cols === String(n)); });
    if (save) store.set('lc2_cols', n);
  };
  var setM = function (n, save) {
    if (!grid) return;
    grid.classList.toggle('is-m1', String(n) === '1');
    grid.classList.toggle('is-m3', String(n) === '3');
    root.querySelectorAll('[data-lc2-mcols]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.lc2Mcols === String(n)); });
    if (save) store.set('lc2_mcols', n);
  };
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-lc2-cols]'); if (c) { setCols(c.dataset.lc2Cols, true); return; }
    var m = e.target.closest('[data-lc2-mcols]'); if (m) { setM(m.dataset.lc2Mcols, true); }
  });
  if (store.get('lc2_cols')) setCols(store.get('lc2_cols'));
  if (store.get('lc2_mcols')) setM(store.get('lc2_mcols'));

  /* Filtre paneli */
  var panel = root.querySelector('[data-lc2-panel]');
  var form = root.querySelector('[data-lc2-form]');
  var open = function () { root.classList.add('is-filter'); panel.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); var f = panel.querySelector('input, a, button'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 300); };
  var close = function () { root.classList.remove('is-filter'); panel.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); };
  var apply = function () {
    var p = new URLSearchParams(new FormData(form));
    Array.from(p.keys()).forEach(function (k) { if (p.getAll(k).every(function (v) { return v === ''; })) p.delete(k); });
    var clean = new URLSearchParams();
    p.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
    location.href = form.getAttribute('action') + (clean.toString() ? '?' + clean.toString() : '');
  };
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lc2-open]')) { open(); return; }
    if (e.target.closest('[data-lc2-close]')) { close(); return; }
    if (e.target.closest('[data-lc2-apply]')) { apply(); }
  });
  if (form) form.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-filter')) close(); });
})();
